/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { BetView } from '../../services/betting';

interface BetProps {
    bet: BetView;
}

export const BetComponent: React.FC<BetProps> = (props) => {
    if (props.bet) {
        return (
            <span>
                <span className="float-left">
                    {props.bet.bet1}:{props.bet.bet2}
                </span>
                <span className="btn-r1--points p-0 ms-1 ps-sm-1 pe-sm-1 ">{props.bet.points}</span>
            </span>
        );
    } else {
        return null;
    }
};
